(() => {
  const root = document.querySelector('product-info[id^="MainProduct-"]');
  const gallery = root?.querySelector('.product__media-wrapper');
  if (!root || !gallery || root.dataset.bbPreviewFollow) return;
  root.dataset.bbPreviewFollow = 'true';
  root.classList.add('bb-preview-follow');
  const dock = document.createElement('aside');
  dock.className = 'bb-product-preview-dock';
  dock.hidden = true;
  dock.setAttribute('aria-label', 'Güncel pasta görünümü');
  dock.innerHTML = '<canvas width="480" height="480" role="img" aria-label="Pastanızın güncel görünümü"></canvas><div class="bb-product-preview-dock__copy"><strong>Pastanızın görünümü</strong><button type="button">Büyük görsele dön</button></div>';
  document.body.append(dock);
  const canvas = dock.querySelector('canvas'), ctx = canvas.getContext('2d');
  const mobile = matchMedia('(max-width: 767.98px)');
  let timer = 0, scheduled = false;
  function source() {
    const active = gallery.querySelector('.swiper-slide-active') || gallery;
    return active.querySelector('.pplr_preview_wrapper canvas') || gallery.querySelector('.pplr_preview_wrapper canvas') || active.querySelector('.product__media img') || gallery.querySelector('.product__media img');
  }
  function paint() {
    timer = 0;
    if (dock.hidden || document.hidden) return;
    const image = source();
    const w = image?.naturalWidth || image?.width, h = image?.naturalHeight || image?.height;
    if (image && w > 0 && h > 0) {
      const scale = Math.min(480 / w, 480 / h);
      ctx.clearRect(0, 0, 480, 480);
      ctx.drawImage(image, (480 - w * scale) / 2, (480 - h * scale) / 2, w * scale, h * scale);
    }
    timer = setTimeout(paint, 120);
  }
  function update() {
    scheduled = false;
    if (!root.isConnected) { clearTimeout(timer); dock.remove(); return; }
    const viewport = window.visualViewport;
    const header = document.querySelector('[is="sticky-header"]') || document.querySelector('header.header');
    const box = header?.getBoundingClientRect();
    const headerBottom = box && box.top <= 1 && box.bottom > 0 ? box.bottom : 0;
    const top = Math.max(viewport?.offsetTop || 0, headerBottom);
    dock.style.setProperty('--bb-preview-top', `${top}px`);
    root.style.setProperty('--bb-preview-top', `${top}px`);
    const height = Math.max(96, Math.min(160, (viewport?.height || innerHeight) * .22));
    canvas.style.width = canvas.style.height = `${height}px`;
    const show = mobile.matches && gallery.getBoundingClientRect().bottom <= top && root.getBoundingClientRect().bottom > top + height + 64;
    dock.hidden = !show;
    root.style.setProperty('--bb-preview-clearance', `${show ? top + height + 40 : top + 24}px`);
    if (show && !timer) paint();
    if (!show) { clearTimeout(timer); timer = 0; }
  }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } }
  function revealField() {
    if (dock.hidden) return;
    const active = document.activeElement;
    if (!root.contains(active) || !active.matches('input:not([type=hidden]),select,textarea')) return;
    const field = active.getBoundingClientRect(), preview = dock.getBoundingClientRect();
    const bottom = (window.visualViewport?.offsetTop || 0) + (window.visualViewport?.height || innerHeight);
    if (field.top < preview.bottom + 16 || field.bottom > bottom - 16) scrollBy({ top: field.top - preview.bottom - 24, behavior: 'instant' });
  }
  dock.querySelector('button').addEventListener('click', () => gallery.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }));
  root.addEventListener('focusin', () => setTimeout(revealField, 250));
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', () => { schedule(); setTimeout(revealField, 250); }, { passive: true });
  document.addEventListener('visibilitychange', schedule);
  mobile.addEventListener('change', schedule);
  update();
})();
